import classnames from 'classnames';
import React from 'react';
import { IconRenderer } from "../../helper/components/IconRenderer.js";
import styles from "./InfoTag.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function InfoTag({
  label,
  icon,
  variant = 'DEFAULT',
  className,
  size = 'DEFAULT'
}) {
  return /*#__PURE__*/_jsxs("span", {
    className: classnames(styles.infoTag, styles[variant], styles[`SIZE_${size}`], {
      [styles.onlyIcon]: !label,
      [styles.iconLeft]: !!icon && !!label
    }, className),
    children: [/*#__PURE__*/_jsx(IconRenderer, {
      icon: icon,
      size: "SMALL"
    }), label && /*#__PURE__*/_jsx("span", {
      children: label
    })]
  });
}